import { mapper } from '@shared/lib';
import { type GamesState } from '../model';

type MapFavoriteGames = (data: any) => Pick<GamesState, 'myGamesDataFromOmegaApi'>;
export const mapFavoriteGames: MapFavoriteGames = mapper([
  { name: 'myGamesDataFromOmegaApi', from: 'games' },
]);
